import React from 'react'
import styles from './Clap.scss'

function Clap(props) {
  const { clapNum } = props
  return (
    <div className="clap-container">
      <style jsx>{styles}</style>
      <span className="clap" />
      <span className="clapNum">{clapNum}</span>
    </div>
  )
}

export default Clap
